export const isOfflineMode = () => process.env.MODE === 'offline';

export function isLocalEAPDevMode() {
  return (
    !process.env.VITE_LOCAL_TUNNEL_ID &&
    (process.env.MODE === 'eap' ||
      process.env.MODE === 'offline' ||
      process.env.NODE_ENV === 'development' ||
      isRemoteEAPDevMode())
  );
}

export function shouldShowDevUI() {
  return (
    // Have to avoid in offline mode since this feature requires fetch calls
    !isOfflineMode() &&
    !process.env.VITE_LOCAL_TUNNEL_ID &&
    (process.env.MODE === 'eap' || isRemoteEAPDevMode())
  );
}

/**
 * Returns true for branch deployments
 */
export function isRemoteEAPDevMode() {
  return process.env.MODE === 'ddev' || process.env.MODE === 'development';
}
